import { Box } from "@mui/material";
import React from "react";

/** Vertical space between the blocks of the exercise detail pages */
export const PaddingBox = () => {
    return <Box sx={{ height: 20 }} />;
};
